export type MerchantClientSettings = {
	hideMigrationBanner?: boolean;
};

export type MerchantClientSettingsConfig = Record<string, MerchantClientSettings>;

export const merchantClientSettingsConfig: MerchantClientSettingsConfig = {
	tonies: {
		hideMigrationBanner: true,
	},
};

export const getMerchantClientSettingState = <K extends keyof MerchantClientSettings>(
	merchantSlug: string, setting: K,
): MerchantClientSettings[K] => {
	const settings = merchantClientSettingsConfig[merchantSlug];

	if (!settings) {
		return false;
	}

	if (setting in settings) {
		return settings[setting];
	}

	return false;
};
